import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import TemperatureVal from './Temperature-slider';
import TextField from '@material-ui/core/TextField';
import  TemperatureConversionService  from '../../services/bunkermaster/TemperatureConversionService';

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'
import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(Parameter, Unit, Fuel1, Fuel2, Target, Blend) {
    return { Parameter, Unit, Fuel1, Fuel2, Target, Blend };
}

const rows = [
    createData('Density', 'Kg / m3', 990.0, 900.0, '', 939),
    createData('Flash Point', '^C', '', '', '', ''),
    createData('Viscosity', 'mm2/s', '180.0', '11.0', '', '25.8'),
    createData('Viscosity Temperature', '0C', '50', '50', '50', '50'),
    createData('Micro Carbon Residue', '%m/m', '', '', '', ''),
    createData('Sulphur', '%m/m', '', '', '', ''),
    createData('Vanadium', '%m/m', '', '', '', ''),
    createData('Sodium ', 'mg/kg', '', '', '', ''),
    createData('Aluminium + mg/kg', '', '', '', '', ''),
];



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function TemperatureConversion() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [temp, setTemp]= React.useState({celcius:0,fahrenheit:""});
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setChecked(event.target.checked);
    };
    const [checked, setChecked] = React.useState(true);
    const onValuesChange = (temperature,field)=>{
        ;
        let result=TemperatureConversionService.CalculateTemperatureConversion(temperature,field)
        if(field==="celcius"){
            setTemp({...temp,...{fahrenheit:result,celcius:temperature}})
        }else if(field==="fahrenheit"){
            setTemp({...temp,...{celcius:result,fahrenheit:temperature}})
        }
    }

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

     const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
        };

        const handleClose = () => {
            setOpen(false);
        };

        const descriptionElementRef = React.useRef(null);
        React.useEffect(() => {
            if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
            }
        }, [open]);

    const getSlidbarValue=(e)=>{
        let result=TemperatureConversionService.CalculateTemperatureConversion(e,"celcius")
        setTemp({...temp,...{fahrenheit:result,celcius:e}})
    }
    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Temperature Conversion</span>

                </div>

                <Box component="div" className="filtercontainer">
                    <Box component="div">

                       


                            <Box component="div" className="bunkarinput">
                <Box component="div" className="pos_relative">
                <Box component="div" className="help_blk">
                    <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>
                   
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                    >
                        <DialogTitle id="scroll-dialog-title">Temperature Conversion</DialogTitle>
                        <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            tabIndex={-1}
                        >
                        <p>This module performs simple Temperature conversions between Celsius and Fahrenheit.</p>
                      
                                   <p className="subtitle">Example </p>
                                    <img className="maxwidth100"  src="/assets/images/Temperature.jpg"></img>
                         
                         
                         
                                <p>Certain default settings can be set in the properties module. When you open the quantity module, you can set base values and default settings like commodity, base temperature and volume unit for that particular calculation. However once a row has been added to the grid, these settings can no longer be changed, unless all data is cleared from the grid.

                                </p>
                         
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                        </DialogActions>
                    </Dialog>
                </Box>
                 </Box>


                                <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl}>
                                <p className="subtitle">Temperature Conversion</p>
                                    <Grid container spacing={3} className="temp-outer">
                                        <Grid item xs={12} sm={12} md={5}>
                                            <Box component="div" className=" Temperaturecon ">
                                                
                                                <Box component="div" className="bunkarinput resultinner">

                                                    <form className={classes.root}  autoComplete="off">
                                                        <Box component="div" className="padbtm25">

                                                            <TextField id="standard-basic" type="number" value={temp.celcius} onChange={(e) => onValuesChange(e.target.value, "celcius")} />
                                                            <span className="resultmv"> <sup>o</sup> C</span>

                                                        </Box>

                                                    </form>
                                                </Box>



                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={3} className="temp-center">

                                            <TemperatureVal getSlidbarValue={getSlidbarValue} type="number" tempVal={temp.celcius}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <Box component="div" className="Temperaturecon ">
                                                
                                                <Box component="div" className="bunkarinput resultinner">

                                                    <form className={classes.root}  autoComplete="off">
                                                        <Box component="div" className="padbtm25">

                                                            <TextField id="standard-basic" type="number" value={temp.fahrenheit} onChange={(e) => onValuesChange(e.target.value, "fahrenheit")} />
                                                            <span className="resultmv"> <sup>o</sup> F</span>

                                                        </Box>

                                                    </form>
                                                </Box>



                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={6} className="displaynone">
                                            <label className=" ">Temperature</label>
                                            <BootstrapInput type="number" className="mr20" />
                                        
                                            <label className=" ">Temperature Unit</label>
                                            <Select labelId="outlined-label" className="mr20 bunkerselect" >
                                                <MenuItem value={10}> <sup>o</sup>C</MenuItem>
                                                <MenuItem value={20}> <sup>o</sup>F</MenuItem>

                                            </Select>

                                       

                                            <button type="button" className={classes.btn1} >Calculate</button>{''}
                                            <button type="reset" className={classes.btn2}   >Reset</button>
                                         
                                            <label className=" ">Converted Temperature </label>
                                            <BootstrapInput  type="number" className="mr20 disableinput" disabled />
                                        </Grid>


                                    </Grid>



                                </FormControl>




                            </Box>


                         



                    </Box>


                </Box>










            </div>
        </div>
    );
}
export default TemperatureConversion;
